import { getFileExtensionFromUrl } from "./getFileExtensionFromUrl";

export async function urlToFile(url: string, filename: string): Promise<File> {
  const response = await fetch(url);
  const blob = await response.blob();

  const extension = getFileExtensionFromUrl(url);
  const finalFilename = filename.endsWith(`.${extension}`)
    ? filename
    : `${filename}.${extension}`;

  return new File([blob], finalFilename, { type: blob.type });
}
